import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const GuestInvitedStatus = ({eventId, inviteGuests, guestList}) => {
    const [accepted, setaccepted] = useState(0);
    const [notAccepted, setnotAccepted] = useState(0);
    const [waiting, setwaiting] = useState(0);

    useEffect(() => {
        const loadStatus = () => {
            let attending = 0; 
            let notattending = 0; 
            let pending = 0; 
            for (let i = 0; i < guestList.length; i++) {
                if (guestList[i].RSVP === "accepted") {
                    attending = attending + 1
                }
                if (guestList[i].RSVP === "pending") {
                    pending = pending + 1
                }
                if (guestList[i].RSVP === "decline") {
                    notattending = notattending + 1
                }
                if (i === (guestList.length - 1)) {
                    setaccepted(attending)
                    setnotAccepted(notattending)
                    setwaiting(pending)
                }
            }
        }
        loadStatus()
        
    }, [guestList])

    return(
        <div className="invite-status">
            <div className="top">
                <h5>RSVP By Date</h5>
                <h5>Fev 15, 2022</h5>
            </div>
            <div className="status-modifier">
                <div className="status">
                    <h5>Attending: <span>{accepted}</span></h5>
                    <h5>Not Attending: <span>{notAccepted}</span></h5>
                    <h5>Awating: <span>{waiting}</span></h5>
                </div>
                <div className="controler">
                    <button onClick={() => inviteGuests(eventId)}>Invite all</button>
                </div>
            </div>
        </div>
    );
};

export default GuestInvitedStatus;
